<template>
  <div class="chrome">
    <div class="extend_header">简历插件下载</div>
    <div class="extend_des">
      <p>1、一键导入各大招聘网站的求职者信息，省去一系列繁琐的操作；</p>
      <!-- <p>2、快速查找、购买第三方渠道的简历并同步至系统，方便快捷；</p> -->
      <p>2、目前支持的网站包括BOSS直聘、拉勾、猎聘；</p>
      <p>3、支持的浏览器分别是：</p>
    </div>
    <div class="extend_flate">
      <div class="safeWrapper" @click="goSafe('chrome')">
        <div class="extend_flate_item">
          <div class="safeBox">
            <img src="../../assets/img/extend/chrome.png" />
            <span>Chrome浏览器</span>
          </div>
        </div>
        <div class="text">Windows/Mac版</div>
      </div>
      <div class="safeWrapper" @click="goSafe('360')">
        <div class="extend_flate_item">
          <div class="safeBox">
            <img src="../../assets/img/extend/360fast.png" />
            <span>360极速浏览器</span>
          </div>
        </div>
        <div class="text">Windows/Mac版</div>
      </div>
      <!-- <div class="safeWrapper" @click="goSafe('360')">
        <div class="extend_flate_item">
          <div class="safeBox">
            <img src="../../assets/img/extend/360safe.png" />
            <span>360安全下载</span>
          </div>
        </div>
        <div class="text">Windows/Mac版</div>
      </div>-->
      <div class="safeWrapper" @click="goSafe('sogu')">
        <div class="extend_flate_item">
          <div class="safeBox">
            <img src="../../assets/img/extend/sogosafe.png" />
            <span>搜狗浏览器</span>
          </div>
        </div>
        <div class="text">Windows版</div>
      </div>
      <div class="safeWrapper" @click="goSafe('qq')">
        <div class="extend_flate_item">
          <div class="safeBox">
            <img src="../../assets/img/extend/qqsafe.png" />
            <span>QQ浏览器</span>
          </div>
        </div>
        <div class="text">Windows版</div>
      </div>
    </div>
    <div class="oneHeader">
      <div class="otherOne">
        <a
          href="http://a.hire66.com/download/yzp"
          download="http://a.hire66.com/download/yzp"
          class="downloadExtend"
        >
          <b class="blue">【点击这里】</b>
        </a>下载插件，按照下面
        <b class="yellow">（Chrome浏览器）</b>操作步骤安装插件
      </div>
      <div class="otherTwo">
        &nbsp;&nbsp;其它浏览器
        <b class="blue safeHove" @click="safeScroll('otherCourse')">【360极速浏览器】</b>
        <b class="blue safeHove" @click="safeScroll('soguCourse')">【搜狗浏览器】</b>
        <b class="blue safeHove" @click="safeScroll('qqCourse')">【QQ浏览器】</b>
        操作指南请向下滑动页面
      </div>
    </div>
    <div class="extend_tabs">
      <div class="extend_tabs_header">
        <div
          class="extend_tabs_header_item"
          @click="changeTab('window')"
          :class="current =='window' ? 'current':''"
        >Windows版本操作说明</div>
        <div
          class="extend_tabs_header_item"
          :class="current =='mac' ? 'current':''"
          @click="changeTab('mac')"
        >Mac版本操作说明</div>
      </div>
      <div class="extend_tabs_mac">
        <div class="extend_bowser">
          <span>1</span>
          <p>解压缩文件：下载文件并解压</p>
        </div>
        <div class="extend_bowser">
          <span>2</span>
          <p>将安装的（Chrome、360极速、搜狗、QQ）浏览器设置为默认浏览器，以Chrome浏览器为例</p>
        </div>
        <img :src="require(`../../assets/img/extend/${current}_1.gif`)" class="gif" />
        <div class="extend_bowser">
          <span>3</span>
          <p>安装下载的插件，并使用手机钉钉-【易招聘】-【我的】-【扫一扫】扫码绑定</p>
        </div>
        <img :src="require(`../../assets/img/extend/${current}_2.gif`)" class="gif" />
      </div>
      <div class="extend_tabs_window"></div>
    </div>

    <!-- 其他浏览器 -->
    <div id="otherCourse" class="extend_header otherTitle">其他浏览器安装教程</div>
    <div class="extend_tabs">
      <div class="extend_tabs_header">
        <div
          class="extend_tabs_header_item"
          @click="changeOtherTab('360win')"
          :class="other =='360win' ? 'current':''"
        >360极速浏览器Windows版</div>
        <div
          class="extend_tabs_header_item"
          :class="other =='360mac' ? 'current':''"
          @click="changeOtherTab('360mac')"
        >360极速浏览器Mac版</div>
      </div>
      <div class="extend_tabs_mac">
        <div class="extend_bowser">
          <span>1</span>
          <p>解压缩文件：下载文件并解压</p>
        </div>
        <div class="extend_bowser">
          <span>2</span>
          <p v-if="other === '360win'">
            在360极速浏览器菜单中找到
            <i class="textBlue">【工具】-【管理扩展】</i>，点击进入
          </p>
          <p v-else>
            在360极速浏览器菜单中找到
            <i class="textBlue">【应用中心】</i>点击进入；再点击
            <i class="textBlue">【已安装扩展】</i>
          </p>
        </div>
        <img
          v-if="other === '360win'"
          :src="require(`../../assets/img/extend/3601.png`)"
          class="img"
        />
        <img v-else :src="require(`../../assets/img/extend/360mac1.png`)" class="img" />
        <div class="extend_bowser">
          <span>3</span>
          <p v-if="other === '360win'">
            将下载的yzp文件夹拖入，或点击
            <i class="textBlue">【加载已解压的扩展程序】</i>；再点击弹出窗口的
            <i class="textBlue">【添加】</i>，完成安装
          </p>
          <p v-else>
            打开
            <i class="textBlue">【开发者模式】</i>，将下载的yzp文件夹拖入，或点击
            <i class="textBlue">【加载已解压的扩展程序】</i>；再点击弹出窗口的
            <i class="textBlue">【添加扩展程序】</i>，完成安装
          </p>
        </div>
        <img
          v-if="other === '360win'"
          :src="require(`../../assets/img/extend/3602.png`)"
          class="img"
        />
        <img v-else :src="require(`../../assets/img/extend/360mac2.png`)" class="img" />
      </div>
      <div class="extend_tabs_window"></div>

      <template v-if="other === '360win'">
        <!-- 搜狗浏览器 -->
        <div id="soguCourse" class="extend_tabs_header">
          <div class="extend_tabs_header_item current" @click="changeTab('window')">搜狗浏览器Window版</div>
        </div>
        <div class="extend_tabs_mac">
          <div class="extend_bowser">
            <span>1</span>
            <p>解压缩文件：下载文件并解压</p>
          </div>
          <div class="extend_bowser">
            <span>2</span>
            <p>
              找到解压的yzp文件夹，鼠标右击文件，
              <i class="textBlue">【打开方式】</i>选择用
              <i class="textBlue">【搜狗浏览器】</i>打开
            </p>
          </div>
          <img :src="require(`../../assets/img/extend/sogou1.png`)" class="img" />
          <div class="extend_bowser">
            <span>3</span>
            <p>
              搜狗浏览器会提示拓展存在风险（忽略该提示），勾选信任，点击
              <i class="textBlue">【确认安装】</i>
            </p>
          </div>
          <img :src="require(`../../assets/img/extend/sogou2.png`)" class="img" />
        </div>

        <!-- qq浏览器 -->
        <div class="extend_tabs_header" id="qqCourse">
          <div class="extend_tabs_header_item current" @click="changeTab('window')">QQ浏览器Window版</div>
        </div>
        <div class="extend_tabs_mac">
          <div class="extend_bowser">
            <span>1</span>
            <p>解压缩文件：下载文件并解压</p>
          </div>
          <div class="extend_bowser">
            <span>2</span>
            <p>
              在QQ浏览器菜单中找到
              <i class="textBlue">【应用中心】</i>，点击进入
            </p>
          </div>
          <img :src="require(`../../assets/img/extend/qq1.png`)" class="img" />
          <div class="extend_bowser">
            <span>3</span>
            <p>
              点击
              <i class="textBlue">【管理我的应用】</i>菜单，将下载的yzp文件夹拖入，或点击
              <i class="textBlue">【加载已解压的扩展程序】</i>；点击弹出窗口的
              <i class="textBlue">【添加扩展程序】</i>，完成安装
            </p>
          </div>
          <img :src="require(`../../assets/img/extend/qq2.png`)" class="img" />
        </div>
      </template>
    </div>

    <el-dialog
      title="安装插件提醒"
      :visible.sync="dialogVisible"
      width="25%"
      :show-close="false"
      :before-close="handleClose"
    >
      <span>检测到该浏览器未安装插件，请安装后再发布岗位！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>



<script>
export default {
  components: {},
  data() {
    return {
      text: "",
      url: "",
      current: "window",
      other: "360win",
      dialogVisible: false,
      timer: ""
    };
  },
  methods: {
    goSafe(val) {
      switch (val) {
        case "chrome":
          window.open("https://www.google.cn/chrome/", "_blank");
          break;
        case "360":
          window.open("https://browser.360.cn/ee/", "_blank");
          break;
        case "sogu":
          window.open("https://ie.sogou.com/", "_blank");
          break;
        case "qq":
          window.open("https://browser.qq.com/?adtag=SEM170314031", "_blank");
          break;
      }
    },
    safeScroll(id) {
      this.other = "360win";
      this.$nextTick(() => {
        document.getElementById(id).scrollIntoView();
      });
    },
    handleClose() {
      let timer = this.timer;
      clearInterval(timer);
      this.dialogVisible = false;
    },
    closeDialog() {
      let timer = this.timer;
      clearInterval(timer);
      this.dialogVisible = false;
    },
    changeOtherTab(val) {
      this.other = val;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    isTag() {
      let position_id = this.getUrlKey("position_id");
      let channel_id = this.getUrlKey("channel_id");
      var timer = setTimeout(() => {
        let dom = document.querySelector("#extensionYzpXrxs");
        if (dom) {
          this.dialogVisible = false;
          clearInterval(timer);
          this.is_chrome(position_id, channel_id);
        } else {
          this.dialogVisible = true;
        }
      }, 1500);
      this.timer = timer;
    },
    is_chrome(position_id, channel_id) {
      let channel_json = [
        {
          id: 1,
          url:
            // "https://www.zhipin.com/chat/im?mu=%2Fvue%2Findex%2F%23%2Fdashboard%2Fjob-manage%2Fjob-edit%2F0"
            "https://www.zhipin.com/web/chat/job/edit?encryptId=0"
        },
        {
          id: 2,
          url: "https://lpt.liepin.com/ejobedit/editsocietyejob"
        },
        {
          id: 3,
          url: "https://easy.lagou.com/position/multiChannel/createPosition.htm"
        },
        {
          id: 5,
          url: "https://rd5.zhaopin.com/job/publish"
        },
        {
          id: 4,
          url: "https://ehire.51job.com/Jobs/JobEdit.aspx?Mark=New"
        }
      ];
      const formData = {
        jobName: "",
        jobDesc: "",
        job_description_notags: "",
        department: "",
        job_highlights: "",
        hireType: "",
        hireTypeText: "",
        workAge: "",
        workAgeText: "",
        eduGrade: "",
        eduGradeText: "",
        minSalary: "",
        maxSalary: "",
        hireNum: ""
      };
      let chrome = window.chrome;
      let jumpUrl = channel_json.find(item => item.id == channel_id).url;
      let timer = setInterval(() => {
        let base_url = "https://da.hire66.com/";
        let dom = document.querySelector("#extensionYzpXrxs");
        if (dom) {
          clearInterval(timer);
          var id = dom.getAttribute("data-extensionId");
          console.log(id);
          var version = dom.getAttribute("data-version");
          // 数据请求
          if (id) {
            var xhr = new XMLHttpRequest();
            xhr.open(
              "GET",
              `${base_url}apiweb/position/extendPositionDetail?position_id=${position_id}`,
              false
            );
            xhr.setRequestHeader("Content-type", "application/json");
            xhr.onreadystatechange = function() {
              if (xhr.readyState && xhr.status == 200) {
                if (xhr.responseText) {
                  let data = JSON.parse(xhr.responseText);
                  if (data.status_code == 200) {
                    let {
                      name,
                      department_name,
                      education_req,
                      job_description,
                      job_highlights,
                      salary_range,
                      work_num,
                      job_description_notags,
                      recruitment_count,
                      work_type
                    } = data.data;
                    salary_range = salary_range
                      ? salary_range.replace(/[K|k]/g, "000")
                      : "";
                    formData.jobName = name;
                    formData.jobDesc = job_description;
                    formData.department = department_name;
                    formData.job_highlights = job_highlights;
                    formData.eduGradeText = education_req;
                    formData.minSalary = salary_range.split("-")[0] - 0;
                    formData.maxSalary = salary_range.split("-")[1] - 0;
                    formData.workAgeText = work_num
                      ? work_num.replace(/~/g, "-")
                      : "";
                    formData.job_description_notags = job_description_notags;
                    formData.hireNum = recruitment_count;
                    formData.hireType = work_type;
                    console.log(formData);
                    chrome.runtime.sendMessage(
                      id,
                      {
                        type: "POSITION_SAVE_PBULIC_DATA",
                        pubilcData: {
                          position_id: position_id,
                          channel_id: channel_id,
                          fromData: formData
                        }
                      },
                      function(e) {
                        console.log(e, "POSITION_SAVE_PBULIC_DATA response");
                        // if (e.status == "success") {
                        window.location.href = jumpUrl;
                        return;
                        // }
                      }
                    );
                  }
                }
              }
            };
            xhr.send();
          }
        } else {
          console.log("暂无插件");
        }
      }, 1000);
    },
    getUrlParams(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //定义正则表达式
      var r = this.props.location.search.substr(1).match(reg);
      console.log(window.location.href.split("?")[1]);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            window.location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    changeTab(val) {
      this.current = val;
    }
  },
  mounted() {
    this.isTag();
  }
};
</script>
<style  scoped lang="scss">
.chrome {
  width: 100%;
  max-width: 1200px;
  margin: 10px auto;
  .textBlue {
    color: #0c7bd7;
    font-style: normal;
  }

  .oneHeader {
    color: #33302d;
    padding: 18px 0 18px 30px;
    border-left: 4px solid #e9b53b;
    background: rgba(248, 248, 251, 1);
    .otherOne {
      font-size: 24px;
    }
    .otherTwo {
      font-size: 18px;
      font-weight: normal;
      padding-top: 10px;
      .safeHove {
        cursor: pointer;
        &:hover {
          color: rgba(12, 134, 220, 0.7);
        }
      }
    }

    .blue {
      color: #0c86dc;
      &:hover {
        color: rgba(12, 134, 220, 0.7);
      }
    }
    .yellow {
      color: #e9b53b;
    }
    a {
      cursor: pointer;
      text-decoration: none;
    }
  }

  .extend_header {
    width: 1200px;
    height: 60px;
    padding: 15px 0;
    padding-left: 30px;
    border-left: 4px solid #e9b53b;
    background: rgba(248, 248, 251, 1);
    margin: 0 auto;
    // margin-bottom: 20px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 48, 45, 1);
    // line-height: 30px;
    box-sizing: border-box;
    &.otherTitle {
      margin-top: 30px;
    }
    .downloadExtend {
      text-decoration: none;
    }
    .blue {
      color: #0c86dc;
    }
    .yellow {
      color: #e9b53b;
    }
    a {
      cursor: pointer;
    }
  }
  .extend_des {
    width: 100%;
    margin-bottom: 20px;
    p {
      width: 100%;
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 48, 45, 1);
      line-height: 24px;
    }
  }
  .safeWrapper {
    text-align: center;
    padding-right: 10px;
    .text {
      color: #6d7278;
      font-size: 14px;
      padding-top: 10px;
    }
  }
  .extend_flate {
    width: 100%;
    // height: 60px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    margin-bottom: 30px;
    .extend_flate_item {
      // margin-right: 10px;
      padding: 17px 20px;
      box-sizing: border-box;
      width: 200px;
      height: 60px;
      background: rgba(248, 248, 251, 1);
      border-radius: 6px;
      border: 1px solid rgba(209, 209, 214, 1);
      display: flex;
      justify-content: center;
      align-content: center;
      cursor: pointer;
      &:hover {
        color: #0c86dc;
        background: #fff;
        border-color: #0c86dc;
        box-shadow: 0px 2px 10px 0px rgba(209, 209, 214, 0.5);
      }
      .safeBox {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 25px;
          height: 25px;
          display: block;
          margin-right: 10px;
        }
        span {
          height: 25px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 25px;
          display: block;
        }
      }
    }
  }
  .extend_tabs {
    width: 100%;
    .extend_tabs_header {
      height: 80px;
      display: flex;
      justify-items: flex-start;
      align-content: center;
      border-bottom: 1px solid #e5e5ea;
      box-sizing: border-box;
      position: relative;
      .extend_tabs_header_item {
        cursor: pointer;
        min-width: 176px;
        height: 80px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 48, 45, 1);
        line-height: 80px;
        &:first-child {
          margin-right: 70px;
        }
      }
      .current {
        border-bottom: 2px solid #0c86dc;
      }
    }
    .extend_bowser {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 20px;
      span {
        display: block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        background: rgba(233, 181, 59, 1);
        border-radius: 7px 7px 7px 0px;
        margin-right: 8px;
      }
      p {
        min-width: 447px;
        height: 30px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 48, 45, 1);
        line-height: 30px;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
    .gif {
      margin-top: 20px;
    }
    .img {
      margin-top: 20px;
      width: 1200px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/chrome.vue